import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { useAdminAuth } from './AdminAuthContext';
import { useNavigate } from 'react-router-dom';
import '../components/css/LoginPopup.css';

const API_BASE = '';

const LoginPopup = ({
  onClose,
  openCreateUserPopup,
  openCreateAdminPopup,
  openChangePassword
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const { adminLogin } = useAdminAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_BASE}/api/login`,
        { email, password },
        { withCredentials: true }
      );

      localStorage.removeItem('token');
      localStorage.removeItem('adminToken');

      if (response.data.type === 'admin') {
        adminLogin(response.data.token);
      } else if (response.data.type === 'user') {
        login(response.data.token);
      }

      onClose();
    } catch (error) {
      console.error('Error logging in:', error);
      alert('Invalid credentials');
    }
  };

  const handleForgotPassword = () => {
    onClose();
    navigate('/forgot-password');
  };

  return (
    <div className="login-popup">
      <div className="login-popup-overlay" onClick={onClose}></div>
      <div className="login-popup-content">
        <button type="button" className="close-button" aria-label="Close login" onClick={onClose}>×</button>
        <form onSubmit={handleSubmit}>
          <h2>Login</h2>
          <div className="form-group">
            <label htmlFor="login-email">Email/Username:</label>
            <input
              id="login-email"
              autoComplete="username"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="login-password">Password:</label>
            <input
              id="login-password"
              autoComplete="current-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit">Login</button>
        </form>

        <div className="button-row">
          <button type="button" onClick={openCreateUserPopup}>Create User</button>
          <button type="button" onClick={handleForgotPassword}>Forgot Password?</button>
        </div>
      </div>
    </div>
  );
};

export default LoginPopup;
